export default "__VITE_ASSET__69fb1e61__"